import { Spinner } from "evergreen-ui";
import React from "react";
import styled from "styled-components";

const Container = styled.button<any>`
  width: ${(props) => props.width};
  color: ${(props) => props.theme.primaryTextColor};
  background-color: ${(props) => props.theme.primaryColor};
  padding: 0.8rem 1.2rem;
  border-radius: 20px;
  text-align: center;
  font-weight: 600;
  cursor: pointer;
  :hover {
    opacity: 0.7;
  }
  :disabled {
    opacity: 0.7;
    cursor: auto;
  }
  border-style: none;
`;

const Label = styled.span`
  display: flex;
  flex-direction: row;
`;

interface IProps {
  label: any;
  onClick: any;
  disabled?: boolean | any;
  width?: string | any;
  loading?: boolean;
}
const Button: React.SFC<IProps> = ({
  label,
  onClick,
  loading = false,
  disabled,
  width = "100%",
}) => (
  <Container width={width} onClick={onClick} disabled={disabled || loading}>
    {loading ? (
      <Label>
        <Spinner color="white" marginRight={"0.5rem"} size={12} /> Loading...{" "}
      </Label>
    ) : (
      label
    )}
  </Container>
);

export default Button;
